<template>
  <div>
    <!-- Debug markerObjects: {{ markerObjects }}<br /> -->
    <!-- markerObjects[0].lat {{ markerObjects[0].lat }}, markerObjects[0].lng
    {{ markerObjects[0].lng }} <br /> -->

    <!-- Map -->
    <section>
      <l-map
        :style="getHeight"
        :zoom="zoom"
        :minZoom="3"
        :center="getCenterPosition"
        @click="setMapMarker"
      >
        <l-tile-layer
          :url="map.url"
          :attribution="map.attribution"
        ></l-tile-layer>
        <l-marker
          :lat-lng="[value.lat, value.lng]"
          v-for="(value, index) in markerObjects"
          :key="index"
          ><l-popup v-if="action == 'stationSetupOverview'"
            ><StationSetup
              :action="'stationLayoutView'"
              :stationSetupID="value.id"
            /> </l-popup
        ></l-marker>
      </l-map>
    </section>
  </div>
</template>

<script setup>
import "leaflet/dist/leaflet.css";
import { LMap, LTileLayer, LMarker, LPopup } from "@vue-leaflet/vue-leaflet";

import StationSetup from "@/components/forms/StationSetupForm.vue";
</script>

<script>
export default {
  name: "MapComponent",

  props: ["zoom", "action", "height", "markerObjects"],
  emits: ["setCoordinates"],

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  data() {
    return {
      map: {
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        attribution:
          '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      },
    };
  },

  methods: {
    setMapMarker(event) {
      // console.group("setMapMarker", event);

      if (event.latlng && this.action === "edit") {
        // console.log("Send emit");
        this.lat = event.latlng.lat;
        this.lng = event.latlng.lng;

        this.$emit("setCoordinates", this.lat, this.lng);
      }

      // console.groupEnd();
    },
  },

  computed: {
    getHeight() {
      return `height: ${this.height}vh`;
    },
    getCenterPosition() {
      // console.log("getCenterPosition");
      let center = [0, 0];
      if (
        this.markerObjects.length != undefined &&
        this.markerObjects.length > 0
      ) {
        center = [this.markerObjects[0].lat, this.markerObjects[0].lng];
      }
      // console.log("center", center);
      return center;
    },
  },
};
</script>
